
export default {
  name: 'app',
};
